import { CheckCircle, Plus } from 'iconoir-react'
import moment from 'moment'
import { Button } from 'app/components/ui/button'
import { TableEmptyState } from 'app/components/ui/table-empty-state'
import { DAY_KEY, DUE_DAY_PHRASES } from 'lib/taskCalendar'
import type { TaskJson } from 'app/types/entities'
import { TaskCalendarChip } from './TaskCalendarChip'
import { TaskWeekStrip } from './TaskWeekStrip'

/** One day's tasks as a list: Google's Schedule list and Todoist's Today. */
export function TaskCalendarDay({
  anchor,
  tasksByDay,
  onOpenTask,
  onToggleStatus,
  onCreate,
  onOpenDay,
}: {
  anchor: moment.Moment
  tasksByDay: Map<string, TaskJson[]>
  onOpenTask: (task: TaskJson) => void
  onToggleStatus: (task: TaskJson) => void
  onCreate: (day: moment.Moment) => void
  onOpenDay: (day: moment.Moment) => void
}) {
  const tasks = tasksByDay.get(anchor.format(DAY_KEY)) ?? []
  return (
    <div className="flex min-h-0 flex-1 flex-col gap-3">
      <div className="md:hidden">
        <TaskWeekStrip anchor={anchor} tasksByDay={tasksByDay} onOpenDay={onOpenDay} />
      </div>
      <div className="flex min-h-0 flex-1 flex-col gap-2 overflow-y-auto">
        {tasks.length === 0 ? (
          <div className="rounded-md border border-default bg-surface">
            <TableEmptyState
              tone="positive"
              icon={<CheckCircle className="h-6 w-6" strokeWidth={1.5} />}
              title="Nothing due"
              description={`No tasks are due ${anchor.calendar(null, DUE_DAY_PHRASES)}.`}
              action={
                <Button variant="secondary" size="sm" onClick={() => onCreate(anchor)}>
                  <Plus />
                  New Task
                </Button>
              }
            />
          </div>
        ) : (
          <>
            {tasks.map((task) => (
              <TaskCalendarChip
                key={task.id}
                task={task}
                variant="card"
                onOpen={() => onOpenTask(task)}
                onToggleStatus={() => onToggleStatus(task)}
              />
            ))}
            <Button variant="dashed" size="sm" className="self-start" onClick={() => onCreate(anchor)}>
              <Plus />
              New Task
            </Button>
          </>
        )}
      </div>
    </div>
  )
}
